import { useEffect, useState } from 'react';
import { Container, Snackbar } from '@mui/material';
import { Formik } from 'formik';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';

import Alert from 'src/components/Alert';
import { CONSTANTS } from 'src/commons';
import MealForm from './mealForm'

const EditMealModal = ({ handleCloseModal ,setMeals ,meals ,editData }) => {
  const date = dayjs().format('YYYY-MM-DD');
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          padding: '.8rem',
          backgroundColor: 'background.default',
          borderRadius: '10px'
        }}
      >
        <Formik
          initialValues={{
            food: editData?.food,
            quantity: editData?.quantity,
            time: dayjs(editData?.time).format('hh:mm'),
            id : editData?.id
          }}
          validationSchema={CONSTANTS.mealValidationSchema}
          onSubmit={async (values) => {
            values.time = dayjs(date + values.time).valueOf();
            const result = meals.map((meal)=>meal.id === values.id ? values : meal)    
            setMeals(result)
            handleCloseModal()
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            touched,
            values
          }) => (
            <MealForm
              errors={errors}
              handleBlur={handleBlur}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
              touched={touched}
              values={values}
              handleCloseModal={handleCloseModal}
              heading={"Update Meal"}
            />
          )}
        </Formik>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackbarState.open}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <div>
            <Alert onClose={handleClose} severity={snackbarState.severity}>
              {snackbarState.message}
            </Alert>
          </div>
        </Snackbar>
      </Container>
    </>
  );
};

export default EditMealModal;
